// import { API_BASE_URL } from '../constants';

import { API_BASE_URL } from 'src/resources/api-constants';
import axios from 'axios';

// import Alert from 'react-s-alert';
import { isAuthenticated, getAccessToken } from './CookiesUtil';

export const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })

    let accessToken = getAccessToken();

    //  if (isAuthenticated()) {
    //     console.log("append access token to authorization");
    //     headers.append('Authorization', 'Bearer ' + accessToken);
    // }

    if (accessToken !== undefined) {
        console.log("append access token to authorization");
        headers.append('Authorization', 'Bearer ' + accessToken);
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);

    options.withCredentials = true;
    options.credentials = "include"

    console.log("APIUtil request options", options);


    return fetch(options.url, options)
        .then(response =>
            response.json().then(json => {

                console.log("response:", response);

                if (!response.ok) {
                    return Promise.reject(json);
                }
                return json;
            })
        );
};

export function getCurrentUser() {

    // this used by social login

    // console.log("in getCurrentUser of APIUTILs.js accessToken",getAccessToken());

    // // if (!localStorage.getItem(ACCESS_TOKEN)) {
    // //     return Promise.reject("No access token set.");
    // // }
    console.log("before access token");

    if (!getAccessToken()) {
        return Promise.reject("No access token set.");
    }

    console.log("APIUtil getCurrentUser() request /user/me getAccessToken():", getAccessToken());


    return request({
        url: API_BASE_URL + "/user/me",

        method: 'GET',
        // withCredentials: true,
    });
}

export function loginAPI(loginRequest) {
    // this used by local email password login
    console.log("loginRequest /api/public/auth/login",API_BASE_URL);
    return request({
        url: API_BASE_URL + "/api/public/auth/login",
        // url: API_BASE_URL + "/auth/logsin",
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(loginRequest)
    });
}


export function phonelogin(phoneloginRequest) {
    // this used by local email password login
    console.log("in getting loginRequest of APIUTILs.js");
    return request({
        url: API_BASE_URL + "/api/public/auth/phonelogin",
        // url: API_BASE_URL + "/auth/logsin",
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(phoneloginRequest)
    });
}

export function phonesignup(signupRequest) {
    return request({
        url: API_BASE_URL + "/api/public/auth/phonesignupverification",
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(signupRequest)
    });
}
export function signup(signupRequest) {
    return request({
        url: API_BASE_URL + "/api/public/auth/signup",
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(signupRequest)
    });
}


export function employeeSignup(signupRequest) {
    return request({
        url: API_BASE_URL + "/api/public/auth/employeesignup",
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(signupRequest)
    });
}



export const RequestAxios = (options, errorOption) => {

    // best place to add token to header

    // if (!localStorage.getItem(BOSS_TOKEN)) {
    //     return Promise.reject("No access token set.");
    // }

    if (!isAuthenticated()) {
        return Promise.reject("No access token set.");
    }


    if (typeof errorOption === 'undefined')
        errorOption = true;


    //  axios.defaults.headers.common['Authorization']='Bearer '+ localStorage.getItem(BOSS_TOKEN);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + getAccessToken();
    axios.defaults.withCredentials = true;

    if (options.isJson) {
        axios.defaults.headers['Content-Type'] = 'Application/json';
    }

    //  append API_BASE_URL
    const config = {
        method: options.method,
        url: API_BASE_URL + options.url,
        responseType: options.responseType,
        data: options.data,
        params: options.params,
        withCredentials: true

    }

    return axios(config)
        .then(res => {
            console.log("api res:", res);
            return res;

        }).catch(error => {
            console.log(config);
            console.log(error);
            //  Alert.error("Http ErrorCode="+error.response.status,{timeout:50000});

            if (errorOption)
                // Alert.error("Request Failed Code:" + error, { timeout: 30000 });


            return 'unsuccess';
        }
        );
};
export const RequestOpenAxios = (options) => {
    // Add authentication header if token exists
    const accessToken = getAccessToken();
    const headers = {};
    
    if (accessToken) {
        headers['Authorization'] = 'Bearer ' + accessToken;
        console.log("Adding token to RequestOpenAxios call");
    }

    const config = {
        method: options.method,
        url: API_BASE_URL + options.url,
        responseType: options.responseType,
        data: options.data,
        params: options.params,
        withCredentials: true,
        body: options.body,
        headers: headers,
        // Explicitly set how axios handles cookies and credentials
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN'
    }
    
    console.log(`Making ${config.method} request to ${config.url} with credentials`);

    return axios(config)
        .then(res => {
            // console.log("api res:",res);
            return res;

        }).catch(error => {
            console.log(`Error in ${config.method} request to ${config.url}:`, error);
            // Only show alert for server errors, not network errors
            if (error.response) {
                // Alert.error(`Request failed with status ${error.response.status}: ${error.message}`, { timeout: 30000 });
            } else {
                // Alert.error(`Network error: ${error.message}`, { timeout: 30000 });
            }
            return error;
        }
        );
};

export const getHello = () => {

    // this defined by longqiang
    // testing api for profile

    return RequestAxios({
        url: "/api/public/hellojson",
        method: 'GET',
        withCredentials: true,
    });
}